module.exports = __webpack_public_path__ + "static/cocoa_cake_slika2-c4dfd2e2326816a3bc567c39249d76b3.jpg";